import React, { useEffect } from "react";
import { ArticleLayout } from "../../components/ArticleLayout";
import { applySeo, buildFaqJsonLd, FaqItem } from "../../lib/seo";
import { PLAY_STORE_URL } from "../../constants/links";
import { FUWALO_OG_SCREENSHOT_URL } from "../../constants/branding";

type SeoArticleProps = {
  kicker?: string;
  title: string;
  description: string;
  canonicalPath?: string;
  faq?: FaqItem[];
  children: React.ReactNode;
};

export function SeoArticle(props: SeoArticleProps) {
  useEffect(() => {
    const jsonLd = props.faq ? buildFaqJsonLd(props.faq) : undefined;

    applySeo({
      title: props.title,
      description: props.description,
      canonicalPath: props.canonicalPath,
      ogType: "article",
      ogImageUrl: FUWALO_OG_SCREENSHOT_URL,
      jsonLd,
    });
  }, [props.title, props.description, props.canonicalPath, props.faq]);

  return (
    <ArticleLayout>
      <article className="article-content" aria-label={props.title}>
        {props.kicker ? <div className="article-kicker">{props.kicker}</div> : null}

        <h1 className="article-title">{props.title}</h1>
        <p className="article-description">{props.description}</p>

        {props.children}

        {props.faq ? (
          <>
            <h2>FAQ</h2>
            <div>
              {props.faq.map((it) => (
                <div key={it.q} style={{ marginBottom: 14 }}>
                  <strong>{it.q}</strong>
                  <p style={{ margin: "6px 0 0" }}>{it.a}</p>
                </div>
              ))}
            </div>
          </>
        ) : null}

        <div className="article-cta-wrap">
          <a
            className="article-cta"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download Fuwalo on Google Play"
          >
            Download Fuwalo on Google Play
          </a>
        </div>
      </article>
    </ArticleLayout>
  );
}

